// src/api/teacherApi.js
import axios from '../utils/axios';

// Kurs İşlemleri
export const getMyCourses = async () => {
  try {
    const response = await axios.get('/courses/my-courses');
    return response.data;
  } catch (error) {
    console.error('Kurslar yüklenirken hata:', error);
    throw error;
  }
};

export const getCourseById = async (courseId) => {
  try {
    const response = await axios.get(`/courses/${courseId}`);
    return response.data;
  } catch (error) {
    console.error('Kurs yüklenirken hata:', error);
    throw error;
  }
};

export const createCourse = async (courseData) => {
  try {
    const formattedData = {
      title: courseData.name || courseData.title,
      description: courseData.description,
      category: courseData.category,
      imageUrl: courseData.imageUrl,
      zoomLink: courseData.zoomLink
    };
   
    const response = await axios.post('/courses', formattedData);
    return response.data;
  } catch (error) {
    console.error('Kurs oluşturulurken hata:', error);
    throw error;
  }
};

// Öğrenci İşlemleri
export const addStudentToCourse = async (courseId, studentEmail) => {
  try {
    const response = await axios.post(`/courses/${courseId}/add-student`, { studentEmail });
    return response.data;
  } catch (error) {
    console.error('Öğrenci eklenirken hata:', error);
    throw error;
  }
};

// ========== DERS İŞLEMLERİ (YENİ SİSTEM) ==========

// Yeni ders oluştur (tüm özelliklerle)
export const createLesson = async (lessonData) => {
  try {
    // lessonData şunları içermeli:
    // { moduleId, title, description, content, zoomLink, scheduledAt, durationMinutes, order, isFree }
    const response = await axios.post('/lessons', lessonData);
    return response.data;
  } catch (error) {
    console.error('Ders oluşturulurken hata:', error);
    throw error;
  }
};

// Modülün derslerini getir
export const getModuleLessons = async (moduleId) => {
  try {
    const response = await axios.get(`/lessons/module/${moduleId}`);
    return response.data;
  } catch (error) {
    console.error('Dersler yüklenirken hata:', error);
    throw error;
  }
};

// Tek ders getir
export const getLessonById = async (lessonId) => {
  try {
    const response = await axios.get(`/lessons/${lessonId}`);
    return response.data;
  } catch (error) {
    console.error('Ders yüklenirken hata:', error);
    throw error;
  }
};

// Ders güncelle
export const updateLesson = async (lessonId, lessonData) => {
  try {
    const response = await axios.put(`/lessons/${lessonId}`, lessonData);
    return response.data;
  } catch (error) {
    console.error('Ders güncellenirken hata:', error);
    throw error;
  }
};

// Ders sil
export const deleteLesson = async (lessonId) => {
  try {
    const response = await axios.delete(`/lessons/${lessonId}`);
    return response.data;
  } catch (error) {
    console.error('Ders silinirken hata:', error);
    throw error;
  }
};

// Öğretmenin tüm derslerini getir
export const getLessonsForTeacher = async () => {
  try {
    const response = await axios.get('/lessons/my-teacher-lessons');
    return response.data;
  } catch (error) {
    console.error('Dersler yüklenirken hata:', error);
    throw error;
  }
};

// ========== MODÜL İŞLEMLERİ ==========

export const getCourseModules = async (courseId) => {
  try {
    const response = await axios.get(`/modules/course/${courseId}`);
    return response.data;
  } catch (error) {
    console.error('Modüller yüklenirken hata:', error);
    throw error;
  }
};

export const createModule = async (moduleData) => {
  try {
    const response = await axios.post('/modules', moduleData);
    return response.data;
  } catch (error) {
    console.error('Modül oluşturulurken hata:', error);
    throw error;
  }
};

export const updateModule = async (moduleId, moduleData) => {
  try {
    const response = await axios.put(`/modules/${moduleId}`, moduleData);
    return response.data;
  } catch (error) {
    console.error('Modül güncellenirken hata:', error);
    throw error;
  }
};

export const deleteModule = async (moduleId) => {
  try {
    const response = await axios.delete(`/modules/${moduleId}`);
    return response.data;
  } catch (error) {
    console.error('Modül silinirken hata:', error);
    throw error;
  }
};

// ========== QUIZ İŞLEMLERİ ==========

export const createQuiz = async (lessonId, quizData) => {
  try {
    const response = await axios.post('/quizzes', { lessonId, ...quizData });
    return response.data;
  } catch (error) {
    console.error('Quiz oluşturulurken hata:', error);
    throw error;
  }
};

export const getQuizById = async (quizId) => {
  try {
    const response = await axios.get(`/quizzes/${quizId}`);
    return response.data;
  } catch (error) {
    console.error('Quiz yüklenirken hata:', error);
    throw error;
  }
};

export const getQuizResults = async (quizId) => {
  try {
    const response = await axios.get(`/quizzes/${quizId}/results`);
    return response.data;
  } catch (error) {
    console.error('Quiz sonuçları yüklenirken hata:', error);
    throw error;
  }
};

// ========== ÖDEV İŞLEMLERİ ==========

export const createAssignment = async (lessonId, assignmentData) => {
  try {
    const response = await axios.post('/assignments', { lessonId, ...assignmentData });
    return response.data;
  } catch (error) {
    console.error('Ödev oluşturulurken hata:', error);
    throw error;
  }
};

export const getAssignmentById = async (assignmentId) => {
  try {
    const response = await axios.get(`/assignments/${assignmentId}`);
    return response.data;
  } catch (error) {
    console.error('Ödev yüklenirken hata:', error);
    throw error;
  }
};

export const getAssignmentSubmissions = async (assignmentId) => {
  try {
    const response = await axios.get(`/assignments/${assignmentId}/submissions`);
    return response.data;
  } catch (error) {
    console.error('Teslimler yüklenirken hata:', error);
    throw error;
  }
};

export const gradeSubmission = async (submissionId, grade, feedback) => {
  try {
    const response = await axios.put(`/assignments/submission/${submissionId}/grade`, { grade, feedback });
    return response.data;
  } catch (error) {
    console.error('Notlandırma hatası:', error);
    throw error;
  }
};